import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { DatabaseItemComponent } from './database-item/database-item.component';
import { DatabasePropertiesComponent } from './database-properties/database-properties.component';
import { EnvironmentDatabasesComponent } from './environment-databases.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        DatabaseItemComponent,
        DatabasePropertiesComponent,
        EnvironmentDatabasesComponent
    ],
    entryComponents: [EnvironmentDatabasesComponent],
    exports: [EnvironmentDatabasesComponent]
})
export class EnvironmentDatabasesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-databases/environment-databases.module.ts